import e2c from 'ed2curve'
import * as StellarSdk from 'stellar-sdk'
import sodium_api from 'libsodium-wrappers'

export async function EdDSA_Encryption(data: any, pub: string) {
    await sodium_api.ready
    const buf = Buffer.from(JSON.stringify(data))

    const boxPub = e2c.convertPublicKey(
        StellarSdk.StrKey.decodeEd25519PublicKey(pub)
    )
    const secretData = sodium_api.crypto_box_seal(buf, boxPub as Uint8Array)

    const base64String = btoa(
        secretData.reduce((d, byte) => d + String.fromCharCode(byte), '')
    )

    return base64String
}
export async function EdDSA_Decryption(data: any, pub: string, sec: string) {
    await sodium_api.ready
    const buf = Buffer.from(data, 'base64')

    const boxPub = e2c.convertPublicKey(
        StellarSdk.StrKey.decodeEd25519PublicKey(pub)
    )

    const secretBuff = StellarSdk.StrKey.decodeEd25519SecretSeed(sec)
    const boxSec = e2c.convertSecretKey(secretBuff)
    const encdata = sodium_api.crypto_box_seal_open(
        buf,
        boxPub as Uint8Array,
        boxSec
    )
    // delete 92 code >> "/"
    const encdata2 = encdata.filter((e) => e !== 92)
    //
    let string = new TextDecoder().decode(encdata2)
    string = JSON.parse(string)
    return string
}
